module.exports = __webpack_public_path__ + "img/985ba788bbadc3f981373846274cfd96.png";